import React from 'react';
import { Icon, Message } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { cohortUrl, requestUrl } from '@/constants/urls';
import RequestIcon from '@/requests/components/RequestIcon';

const SystemCohortMessage = ({ request, userCohort }) => ((
  <Message icon>
    <Icon name="key" className="primary" size="small" />
    <Message.Content>
      <Message.Header>
        <FormattedMessage id="cohort.system.message" />
      </Message.Header>
      {userCohort && (
        <div>
          <FormattedMessage id="cohort.system.original.message" />
          <Link to={cohortUrl(userCohort)} title={userCohort.name}>
            {userCohort.name}
          </Link>
        </div>
      )}
      <div>
        <FormattedMessage id="cohort.system.request.message" />
        <Link to={requestUrl(request)} title={request.name}>
          {request.name}
          <RequestIcon request={request} />
        </Link>
      </div>
      <div />
    </Message.Content>
  </Message>
)
);

export default SystemCohortMessage;
